import React from "react"
import { useSelector } from "react-redux"

import { getSelectedProduct } from "@/onboarding/features/cost_analysis/selectors"
import routes from "@/routes"

const DashboardButton = (): JSX.Element => {
  const product = useSelector(getSelectedProduct)

  return (
    <a
      href={routes.onboarding_season_cost_analysis_path({
        season_id: product.season.id,
        product_id: product.id,
      })}
      className="btn btn-secondary btn-sm"
      role="button"
    >
      <span className="fas fa-chart-line me-2" />
      Season Cost Analysis
    </a>
  )
}

export default DashboardButton
